import React from "react";
import { PotentialMatrixFilters } from "../../../hooks/usePotentialMatrixFilters.hook";
import { PotentialMatrixFilterKeyEnum } from "../../../types/api/filters.type";
import { PotentialMatrixTabLayout } from "../PotentialMatrixTabLayout/PotentialMatrixTabLayout";
import { MatrixGeneralGrid } from "../../../components/MatrixGeneralGrid/MatrixGeneralGrid";
import { MatrixSizes } from "../../../constants/PotentialMatrixConstants";
import { usePotentialMatrixGeneral } from "../../../hooks/potentialMatrix/usePotentialMatrixGeneral.hook";
import { FilterProps } from "../../../types/AppTypes";

type GeneralMatrixProps = {
  filters: PotentialMatrixFilters;
  handleFilters: (
    key: PotentialMatrixFilterKeyEnum,
    value: PotentialMatrixFilters[PotentialMatrixFilterKeyEnum],
  ) => void;
  previousYear?: number;
  createQueryParams: () => FilterProps[];
};

export const GeneralMatrix = ({
  filters,
  handleFilters,
  previousYear,
  createQueryParams,
}: GeneralMatrixProps) => {
  const { data: generalData, isFetching } = usePotentialMatrixGeneral({
    createQueryParams,
    filters,
    enabled: true,
  });

  return (
    <PotentialMatrixTabLayout
      headerProps={{
        filters,
        handleFilters,
        previousYear,
        isIconSwitchEnabled: false,
        showInternalGradeFilters: true,
      }}
    >
      <MatrixGeneralGrid
        data={generalData?.data ?? []}
        screenTotals={generalData?.screenTotals ?? []}
        rangeTotals={generalData?.rangeTotals ?? []}
        impactTotals={generalData?.impactTotals ?? []}
        size={MatrixSizes.BIG}
        yearSelected={Number(filters.year)}
        loading={isFetching}
      />
    </PotentialMatrixTabLayout>
  );
};
